import { ApiError } from "./client.js";

/**
 * APIのエラーコードを、運用者が次に何をすればよいか分かる文言へ変換する。
 * コードごとの意味は docs/api/management-api.md と各仕様書に対応する。
 */

const MESSAGES: Record<string, string> = {
  SEPARATION_OF_DUTIES_REQUIRED:
    "自分が申請した内容は承認できません。別の承認者に依頼してください。",
  PERMISSION_DENIED: "この操作を行う権限がありません。管理者に確認してください。",
  AUTHENTICATION_REQUIRED: "サインインが必要です。画面を再読み込みしてください。",
  USER_NOT_PROVISIONED: "この利用者は登録されていません。管理者に確認してください。",
  USER_SUSPENDED: "この利用者は利用停止中です。管理者に確認してください。",
  VERSION_CONFLICT:
    "他の担当者が先に更新しました。最新の内容を読み込んでからやり直してください。",
  IMMUTABLE_REVISION:
    "公開済みの版は編集できません。新しい下書きを作成してください。",
  INVALID_STATE_TRANSITION:
    "申請の状態が変わっています。最新の内容を読み込んで確認してください。",
  PUBLICATION_VALIDATION_FAILED:
    "公開前検査でエラーが残っています。内容を修正してから再度申請してください。",
  SAME_DAY_CHANGE_CONFIRMATION_REQUIRED:
    "当日変更として確認済みにしてから提出してください。",
  EMERGENCY_OVERRIDE_INVALID:
    "緊急配信の権限、または未来の終了時刻が設定されていません。",
  IDEMPOTENCY_KEY_REUSED:
    "同じ操作キーが別の内容で使われました。画面を再読み込みしてやり直してください。",
  NOT_FOUND: "対象が見つかりません。すでに削除された可能性があります。",
};

export interface ActionFailure {
  message: string;
  code: string | null;
  /** 再読み込みすれば解消し得るか。競合や状態変化がこれに当たる */
  reloadHelps: boolean;
  /** Accessの再認証のため、SPA内の再取得ではなく全画面遷移が必要か。 */
  fullPageReloadRequired: boolean;
}

const RELOAD_HELPS = new Set([
  "VERSION_CONFLICT",
  "INVALID_STATE_TRANSITION",
  "IDEMPOTENCY_KEY_REUSED",
  "NOT_FOUND",
]);

export function describeFailure(error: unknown): ActionFailure {
  if (error instanceof ApiError) {
    return {
      message: MESSAGES[error.code] ?? error.message,
      code: error.code,
      reloadHelps: RELOAD_HELPS.has(error.code),
      fullPageReloadRequired: error.code === "AUTHENTICATION_REQUIRED",
    };
  }
  if (error instanceof Error) {
    return {
      message: error.message,
      code: null,
      reloadHelps: false,
      fullPageReloadRequired: false,
    };
  }
  return {
    message: "操作に失敗しました。",
    code: null,
    reloadHelps: false,
    fullPageReloadRequired: false,
  };
}
